import posthog from 'posthog-js';

export default function useMessagesLimit(): number {
    let messagesLimit = 5;
    const featureFlagValue = posthog.getFeatureFlag('number-of-free-messages-2');
    if (typeof featureFlagValue === 'string') {
        const parsedValue = parseInt(featureFlagValue, 10);
        if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
            messagesLimit = parsedValue;
        }
    }
    return messagesLimit;
} 